<template>
    <div id="calendar">
        <el-row v-wechat-title="title" class="fullcalendarevent">
            <el-col :span="collapse == 1 ? 0 : 6"
                ><LeftScheduleSurgery
                    @mouseOver="changeClass"
                    @mouseOut="updateClass"
                    @checked="changeChecked"
                    @showchangeRoom="showchangeRoom"
                    @showSetAnesDoctor="showSetAnesDoctor"
                    @showClearWorkersForm="showClearWorkersForm"
                    @refetchRightData="refetchRightData"
                    :userListColumn="userListColumn"
                    :userListShowColumn="userListShowColumn"
                    ref="LeftScheduleSurgery"
                ></LeftScheduleSurgery
            ></el-col>
            <el-col :span="collapse == 1 ? 24 : 18">
                <RightScheduleSurgery
                    @triggerCollapse="triggerCollapse"
                    @showTimeLineSetup="showTimeLineSetup"
                    @showRoomSetting="loadSettingForm(arguments)"
                    @reloadLeftList="reloadLeftList"
                    @reloadRoomSettingWorkers="reloadRoomSettingWorkers"
                    @removeLeftSelectData="removeLeftSelectData"
                    :visible.sync="timeLineSetupInfo.dialogFormVisible"
                    :leftcheckedRows="leftcheckedRows"
                    ref="RightScheduleSurgery"
                    @showchangeRoom="showchangeRoom"
                    @userListColumns="userListColumns"
                    @userListShowColumns="userListShowColumns"
                    @showSetAnesDoctor="showSetAnesDoctor"
                    @showClearWorkersForm="showClearWorkersForm"
                    @showEditOtherSchedule="showEditOtherSchedule"
                ></RightScheduleSurgery>
            </el-col>
        </el-row>
        <form-dialog
            :title="roomSettings.title"
            :data="roomSettings.data"
            width="40%"
            :visible.sync="roomSettings.dialogFormVisible"
            :columns="roomSettingsColumns"
            :buttons="roomSettings.buttons"
            @confirm="saveSettings"
        ></form-dialog>
        <!-- <form-dialog
            :title="changeRoom.title"
            :data="changeRoom.data"
            width="40%"
            :visible.sync="changeRoom.dialogFormVisible"
            :columns="changeRoom.changeRoomColumns"
            @confirm="changeRoomSave"
        ></form-dialog> -->
        <cus-dialog :title="changeRoom.title" :visible.sync="changeRoom.dialogFormVisible" width="50%" @confirm="changeRoomSave()">
            <div class="tag-group">
                <el-row><el-col :span="24" class="align-left">手术区：</el-col></el-row>
                <el-row>
                    <div v-for="item in operationWard" :key="item.value" class="tag" :class="{ used: item.value == selectOperatingWardId }" @click="selectOperatingWard(item)" style="margin-top: 10px">
                        {{ item.label }}
                    </div>
                </el-row>
            </div>
            <div class="tag-group">
                <el-row><el-col :span="24" class="align-left">手术间：</el-col></el-row>
                <el-row>
                    <div v-for="item in operationRoom" :key="item.value" class="tag" :class="{ used: item.value == selectOperatingRoomId }" @click="selectOperatingRoom(item)" style="margin-top: 10px">
                        {{ item.label }}
                    </div>
                </el-row>
            </div>
        </cus-dialog>
        <form-dialog
            :title="setAnesDoctor.title"
            :data="setAnesDoctor.data"
            width="40%"
            :visible.sync="setAnesDoctor.dialogFormVisible"
            :columns="setAnesDoctor.setAnesDoctorColumns"
            @confirm="setAnesDoctorSave"
        ></form-dialog>
        <cus-dialog :title="clearWorkers.title" :visible.sync="clearWorkers.dialogFormVisible" width="40%" @confirm="setClearWorkersSave">
            <el-row>
                <el-col :span="24" style="line-height: 35px">
                    <label style="float: left;">角色：</label>
                    <item-input style="width: 80%; float: left;"
                        type="checkboxgroup"
                        v-model="clearWorkers.workerDuties"
                        :options="[
                            { value: `3`, label: `麻醉医生` },
                            { value: `4`, label: `麻醉助手` },
                            { value: `5`, label: `巡回护士` },
                            { value: `6`, label: `器械护士` }
                        ]"
                    ></item-input>
                </el-col>
            </el-row>
        </cus-dialog>
        <TimeLineSetup :visible.sync="timeLineSetupInfo.dialogFormVisible" ref="TimeLineSetup" @settimeLineSetupInfo="settimeLineSetupInfo"></TimeLineSetup>
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import { Draggable } from '@fullcalendar/interaction'
import LeftScheduleSurgery from './LeftScheduleSurgery.vue'
import RightScheduleSurgery from './RightScheduleSurgery.vue'
import TimeLineSetup from './TimeLineSetup.vue'
import { mapGetters } from 'vuex'
export default {
    name: `FullcalendarScheduleSurgery`,
    components: { FullCalendar, LeftScheduleSurgery, RightScheduleSurgery, Draggable, TimeLineSetup },
    props: {},
    data() {
        return {
            title: `手术排程`,
            collapse: 0,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            timeLineSetupInfo: {
                data: {},
                dialogFormVisible: false
            },
            roomSettings: {
                title: `手术间设置`,
                data: {},
                dialogFormVisible: false,
                columns: [],
                buttons: [
                    {
                        label: `应用人员`,
                        type: `primary`,
                        permission: `scheduling:yyry`
                    }
                ]
            },
            leftcheckedRows: [],
            userListColumn: [],
            userListShowColumn: [],
            selectOperatingWardId: 0,
            selectOperatingRoomId: 0,
            status: 0,
            isWarnPlanTimeDifferent: this.$root.IsWarnPlanTimeDifferent,
            changeRoom: {
                title: `选择排程手术间`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                dialogFormVisible: false,
                changeRoomColumns: [{
                    type: `select`,
                    prop: `dic_recovery_ward_id`,
                    label: `手术区`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return d.disabled === false
                        })
                        if (!this.IsCrossRegionScheduling) {
                            data = _.filter(data, { value: this.dic_operating_ward_id })
                        }
                        return data
                    }
                }, {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return (d.value == row.dic_recovery_ward_id)
                        })
                        let rooms = _.filter(data[0] && data[0].operation_room, (d) => {
                            return d.disabled === false
                        }) || []
                        return _.orderBy(rooms, `display_order`)
                    }
                }]
            },
            clearWorkers: {
                title: `清除人员安排`,
                data: {},
                dialogFormVisible: false,
                workerDuties: []
            },
            setAnesDoctor: {
                title: `设置麻醉医生`,
                data: {},
                dialogFormVisible: false,
                setAnesDoctorColumns: [
                    {
                        type: `remoteselect`,
                        prop: `plan_anes_doctor`,
                        label: this.T(`fullcalendar_schedule_surgery.plan_anes_doctor`),
                        isCreatable: true,
                        isEditable: true,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                                if (this.$root.UseASACheck == `1`) {
                                    works = works.map(d => {
                                        return {
                                            label: d.label,
                                            value: d.value,
                                            jianpin: d.jianpin,
                                            card_no: d.card_no,
                                            worker_duty: d.worker_duty,
                                            //  code: d.code,
                                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        }
                                    })
                                }
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }]
            }
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapGetters([
            `operation_ward`,
            `currentUser`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `listview/remove_item`,
            `section`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `screenHeight`,
            `permissions`,
            `active_ward`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        IsCrossRegionScheduling() {
            return _.find(this.permissions, { no: `scheduling:CrossRegionScheduling` }) != undefined
        },
        dic_operating_ward_id: {
            get: function() {
                this.o_dic_operating_ward_id = this.selectOperatingWardId
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationWard() {
            {
                let that = this
                let data = _.filter(that.operation_ward_auth_disabled, (d) => {
                    return d.disabled === false
                })
                if (!this.IsCrossRegionScheduling) {
                    data = _.filter(data, { value: that.dic_operating_ward_id })
                }
                return data
            }
        },
        operationRoom: {
            get() {
                let wardid = this.selectOperatingWardId
                let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                    return (d.value == parseInt(wardid))
                })

                let rooms = _.filter(data[0] && data[0].operation_room, (d) => {
                    return d.disabled === false
                }) || []
                return _.orderBy(rooms, `display_order`)
            },
            set() {}
        },
        screenHeight2() {
            return this.screenHeight
        },
        roomSettingsColumns() {
            // 没有应用麻醉人员权限
            let editWorker = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            // 排程助手按钮权限
            let intelligencePermission = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:intelligence`) > -1

            let cols = [
                {
                    type: `select`,
                    prop: `anesthetist_id`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_anes_doctor`),
                    colspan: 12,
                    readonly: editWorker,
                    showCol: true,
                    options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                },
                {
                    type: `multiselect`,
                    prop: `anesthetist_assistant_id`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_anes_assistants`),
                    colspan: 12,
                    showCol: true,
                    readonly: editWorker,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                        hsworkers.forEach((item, index) => {
                            let mc = _.find(deepworkers, x => x.value == item.value)
                            if (mc) {
                            } else {
                                deepworkers.push(item)
                            }
                        })
                        return deepworkers
                    },
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `circuit_nurse_id`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_circuit_nurse`),
                    options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    colspan: 12,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `equipment_nurse_id`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_equipment_nurse`),
                    options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    colspan: 12,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `分配科室`,
                    options: this.section,
                    showCol: intelligencePermission,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `surgeon_id`,
                    label: `分配术者`,
                    showCol: intelligencePermission,
                    options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `dic_surgery_name`,
                    label: `分配术式`,
                    showCol: intelligencePermission,
                    colspan: 12
                }
            ]
            return _.filter(cols, col => {
                return col.showCol == true
            })
        },
        autoScheduleTitle() {
            return `排程助手(${this.autoScheduleSurgeries.length}/${this.unScheduledLength})`
        }
    },
    methods: {
        changeChecked(items) {
            this.leftcheckedRows = items
        },
        changeClass(items) {
            this.$refs.RightScheduleSurgery.changeClass(items)
        },
        updateClass(item) {
            this.$refs.RightScheduleSurgery.updateClass(item)
        },
        init() {
            this.$refs.TimeLineSetup.init()
        },
        settimeLineSetupInfo(data) {
            if (data) {
                this.timeLineSetupInfo.data = data
                this.$refs.RightScheduleSurgery.gettimeLineSetupInfo(data)
                let api = this.$refs.RightScheduleSurgery.getCalendarApi()
                api.refetchResources()
                this.$refs.RightScheduleSurgery.handleTimelineDayBtnClick()
            } else {
                this.timeLineSetupInfo.data = {}
            }
        },
        loadSettingForm(arg) {
            // 有应用麻醉人员权限
            let haveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) >= 0
            // 有应用护士人员权限
            let haveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) >= 0
            if (haveAnesthetistPermission && !haveNursePermission) {
                this.roomSettings.buttons[0].label = `应用麻醉人员`
            }
            if (!haveAnesthetistPermission && haveNursePermission) {
                this.roomSettings.buttons[0].label = `应用护士人员`
            }
            if (!haveAnesthetistPermission && !haveNursePermission) {
                this.roomSettings.buttons = []
            }
            let id = arg[0]
            let title = arg[1]
            let room = arg[2]
            let date = arg[3]

            this.roomSettings.title = `手术间设置(${title})`
            this.roomSettings.dialogFormVisible = true

            this.roomSettings.data = {
                id: room.room_setting_id,
                date: date,
                dic_operating_room_id: id,
                anesthetist_assistant_id: room.anesthetist_assistant_id && room.anesthetist_assistant_id.split(`,`).map(d => parseInt(d)),
                anesthetist_id: room.anesthetist_id,
                circuit_nurse_id: room.circuit_nurse_id && room.circuit_nurse_id.split(`,`).map(d => parseInt(d)),
                dic_section_id: room.dic_section_id,
                equipment_nurse_id: room.equipment_nurse_id && room.equipment_nurse_id.split(`,`).map(d => parseInt(d)),
                surgeon_id: room.surgeon_id,
                dic_surgery_name: room.dic_surgery_name
            }
        },
        saveSettings(row) {
            let that = this
            // 没有应用麻醉人员权限
            let noHaveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            // 排程助手按钮权限
            let nointelligencePermission = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:intelligence`) === -1

            let req = that.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: row.id,
                date: row.date,
                dic_operating_room_id: row.dic_operating_room_id,
                dic_operating_room: {
                    id: row.dic_operating_room_id
                },
                anesthetist_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_id,
                anesthetist_assistant_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_assistant_id && row.anesthetist_assistant_id.toString(),
                circuit_nurse_id: noHaveNursePermission == true ? null : row.circuit_nurse_id && row.circuit_nurse_id.toString(),
                equipment_nurse_id: noHaveNursePermission == true ? null : row.equipment_nurse_id && row.equipment_nurse_id.toString(),
                dic_section_id: nointelligencePermission == true ? `-1` : (row.dic_section_id || `-1`),
                surgeon_id: nointelligencePermission == true ? `-1` : (row.surgeon_id || `-1`),
                dic_surgery_name: row.dic_surgery_name,
                is_extra: row.isExtraBtnClick,
                surgeryIds: null
            })
            req.then(data => {
                that.$message.success(`保存成功`)
                that.roomSettings.dialogFormVisible = false
                that.$refs.LeftScheduleSurgery.getWorkers()
                let api = that.$refs.RightScheduleSurgery.getCalendarApi()
                api.refetchResources()
            }).catch(e => {})
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
        },
        showTimeLineSetup() {
            this.timeLineSetupInfo.dialogFormVisible = true
            this.$refs.TimeLineSetup.init()
        },
        userListColumns(userListColumn) {
            this.userListColumn = userListColumn
        },
        userListShowColumns(userListShowColumn) {
            this.userListShowColumn = userListShowColumn
        },
        showchangeRoom(leftcheckedRow) {
            this.leftcheckedRows = leftcheckedRow
            console.log(`父页面:` + leftcheckedRow)
            this.changeRoom.title = `选择手术间`
            this.changeRoom.dialogFormVisible = true
            // this.selectOperatingWardId = this.dic_operating_ward_id
            this.status = this.leftcheckedRows && this.leftcheckedRows[0].enum_surgery_status
            // 手术区和手术间默认选中手术申请时填写的
            this.selectOperatingWardId = this.leftcheckedRows && this.leftcheckedRows[0].dic_operating_ward_id
            this.selectOperatingRoomId = this.leftcheckedRows && this.leftcheckedRows[0].dic_operating_room_id
            this.changeRoom.data = { 'dic_recovery_ward_id': this.dic_operating_ward_id, 'status': this.leftcheckedRows && this.leftcheckedRows[0].enum_surgery_status }
            // this.$emit(`showchangeRoom`, this.changeRoom)
        },
        showEditOtherSchedule(id) {
            this.$refs.LeftScheduleSurgery.showEditOtherSchedule(id)
        },
        reloadLeftList(operatingWardId = null) {
            if (operatingWardId != null) {
                // 右侧日历 传 选择的手术区给左侧列表
                this.$refs.LeftScheduleSurgery.dic_operating_ward_id = operatingWardId
            }
            this.$refs.LeftScheduleSurgery.reloadList()
        },
        reloadRoomSettingWorkers(rdate) {
            this.$refs.LeftScheduleSurgery.reloadRoomSettingWorkers(rdate)
        },
        removeLeftSelectData(id) {
            this.$refs.LeftScheduleSurgery.removeLeftSelectData(id)
        },
        refetchRightData() {
            this.$refs.RightScheduleSurgery.refetch()
        },
        selectOperatingWard(item) {
            this.selectOperatingWardId = item.value
            this.selectOperatingRoomId = 0
        },
        selectOperatingRoom(item) {
            this.selectOperatingRoomId = item.value
        },
        changeRoomSave() {
            let that = this
            let surgeryIds = []
            let msgs = ``
            let planmsgs = ``
            let currentDate = this.$refs.RightScheduleSurgery.getCurrentDate()
            let date = that.$moment(currentDate).format(`YYYY-MM-DD`)
            this.leftcheckedRows.map(d => {
                // 存在非当前手术区的数据，弹出提示
                if (d.dic_operating_ward_id != this.selectOperatingWardId) {
                    msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                }
                let plantime = that.$moment(d.plan_time).format(`YYYY-MM-DD`)
                if (plantime != date) {
                    planmsgs += `“${d.patient_name}”计划手术时间:${plantime},`
                }
                surgeryIds.push(d.id)
            })

            if (this.selectOperatingRoomId == 0) {
                this.$message.warning(`请选择手术间!`)
                return
            }

            let row = {
                status: this.status,
                dic_operating_room_id: this.selectOperatingRoomId,
                dic_recovery_ward_id: this.selectOperatingWardId
            }
            if (msgs != ``) {
                msgs = msgs.slice(0, msgs.length - 1)
                return this.$confirm(`请确认${msgs}是否跨区排程?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    this.toPlanSurgery(planmsgs, row, surgeryIds)
                }).catch(e => {})
            } else {
                this.toPlanSurgery(planmsgs, row, surgeryIds)
            }
        },
        toPlanSurgery(planmsgs, row, surgeryIds) {
            if (planmsgs && this.isWarnPlanTimeDifferent == `1`) {
                return this.$confirm(`${planmsgs} 与当前安排的手术时间不一致,是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    this.$refs.RightScheduleSurgery.getchangeRoomSave(row, surgeryIds)
                    this.changeRoom.dialogFormVisible = false
                }).catch(e => { })
            } else {
                this.$refs.RightScheduleSurgery.getchangeRoomSave(row, surgeryIds)
                this.changeRoom.dialogFormVisible = false
            }
        },
        triggerCollapse(collapse) {
            this.collapse = collapse
        },
        showSetAnesDoctor(leftcheckedRow) {
            this.leftcheckedRows = leftcheckedRow
            this.setAnesDoctor.title = `设置麻醉医生`
            this.setAnesDoctor.dialogFormVisible = true
            this.setAnesDoctor.data = { 'plan_anes_doctor': this.plan_anes_doctor, 'surgeryIds': leftcheckedRow }
        },
        setAnesDoctorSave(row) {
            this.$refs.RightScheduleSurgery.setAnesDoctorSave(row)
            this.setAnesDoctor.dialogFormVisible = false
        },
        showClearWorkersForm(surgeryIds) {
            this.clearWorkers.title = `清除手术安排人员`
            this.clearWorkers.dialogFormVisible = true
            this.clearWorkers.workerDuties = null
            this.clearWorkers.data = { surgeryIds: surgeryIds }
        },
        setClearWorkersSave() {
            let that = this
            let surgeryIds = that.clearWorkers.data.surgeryIds
            let duties = that.clearWorkers.workerDuties
            if (duties && duties.length > 0) {
                let api = that.$refs.RightScheduleSurgery.getCalendarApi()
                let inputData = {
                    surgeryIds: surgeryIds,
                    workerDuties: duties
                }
                let req = that.myaxios.put(`/api/Preoperative/Schedule/SetClearWorkersSurgeries`, inputData)
                req.then(data => {
                    that.$message.success(`清除成功`)
                    that.$refs.LeftScheduleSurgery.reloadList()
                    that.$refs.RightScheduleSurgery.refetch()
                    api.refetchResources()
                    that.clearWorkers.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`清除失败`)
                })
            }
        }

    },
    watch: {
    }
}
</script>
<style lang="less">
.surgeryStatus {
    width: 100px;
    display: inline-block;
    height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    // padding: 7px 8px;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        // line-height: 1;
        border-radius: 50%;
        // padding: 7px 8px;
    }
}

.tag {
    width: 130px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    float: left;
    margin-left: 20px;
    background: #cccccc;
    color: #000;
}
.used {
    background: var(--primary-color, #009688);
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/FullcalendarScheduleSurgery.vue